import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useStore } from 'store/useStore'
import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { Order } from 'sections/LKSection/modules/OrderModule/stores/entity/Order'
import { Chat } from 'components/ui'
import { Flex, Skeleton, Title } from 'components/uiKit'
import { useAsyncEffect } from 'utils/hooks/useAsyncEffect'

type OrderCommentsProps = {
  order: Order
}

export const OrderComments = observer(({ order }: OrderCommentsProps) => {
  const { viewOrderUiStore: uiStore } = useStore()

  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  useAsyncEffect(async () => {
    if (order.id) {
      setLoading(true)
      await uiStore.getOrderMessages(order.id)
      setLoading(false)
    }
  }, [order.id])

  const getKey = (key: string) => `${OrderKeys.orderItemPage}.${key}`

  return (
    <>
      {uiStore.allMessages.length > 0 && (
        <Flex vertical gap={8}>
          <Title level={5}>{t(getKey('Переписка с техподдержкой'))}</Title>

          <Skeleton loading={loading}>
            <Chat messages={uiStore.allMessages} />
          </Skeleton>
        </Flex>
      )}
    </>
  )
})
